import { useState as s, useEffect as i } from "react";
const a = 768;
function r() {
  const [o, t] = s(void 0);
  return i(() => {
    const e = window.matchMedia(`(max-width: ${a - 1}px)`), n = () => {
      t(e.matches);
    };
    return e.addEventListener("change", n), t(e.matches), () => e.removeEventListener("change", n);
  }, []), !!o;
}
export {
  r as useIsMobile
};
